import ComplianceView from "../presentation/views/ComplianceView.vue";
export const complianceRoutes = [
    {
        path: "/module/compliance",
        name: "Compliance",
        component: ComplianceView,
        meta: { requiresAuth: true, titleKey: "compliance.title" },
    },
];
export const complianceNavigationItems = [
    {
        labelKey: "module.title",
        children: [
            {
                labelKey: "compliance.title",
                path: "/module/compliance",
                meta: { requiresAuth: true },
            },
        ],
    },
];
